var React = require('react');

function BedAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512,288v64H0V288a64,64,0,0,1,64-64H448A64,64,0,0,1,512,288Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0,352V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V416H448v48a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V352ZM64,224V160a32,32,0,0,1,32-32H208a32,32,0,0,1,32,32v64h32V160a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32v64a66.4,66.4,0,0,1,32,8.88h0V64a32,32,0,0,0-32-32H64A32,32,0,0,0,32,64V232.88h0A66.51,66.51,0,0,1,64,224Z","className":"fa-primary","key":2})]);
}

BedAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BedAlt;

BedAlt.default = BedAlt;
